import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { MarketingPlanProjectionSummary } from "./marketing-plan-projection-summary";
import { MyMarketingPlanEditor } from "./my-marketing-plan-editor";

interface PlanModalProps {
    isOpen: boolean;
    onDismiss: () => void;
}

export const PlanModal: React.FC<PlanModalProps> = ({ isOpen, onDismiss }) => (
    <Panel
        type={PanelType.large}
        headerText="Your current playbook"
        isOpen={isOpen}
        onDismiss={onDismiss}>
        <div className="space-y-6">
            <MarketingPlanProjectionSummary />
            <MyMarketingPlanEditor />
        </div>
    </Panel>
);
